import { useState } from 'react';
import { NavMarker } from 'react-rhumb';
import partial from 'transmute/partial';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { Table } from 'foundations-components/transitional/components/Table';
import SummaryRecipientsTableRow from './SummaryRecipientsTableRow';
import { isUngatedToCHIRPEndpoints } from 'documents-ui/utils/gates';
import { useGetDocumentVisitors } from 'documents-ui/hooks/useGetDocumentVisitors';
import { SummaryRecipientsTableRowCHIRP } from './SummaryRecipientsTableRowCHIRP';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SummaryRecipientsTable = ({
  deckId,
  deckVisitors,
  documentVisitorSearchQuery,
  hasMore,
  fetchDocumentVisitors,
  onViewDetails,
  onViewDetailsCHIRP,
  pageLimit,
  searchQueryCHIRP
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const isUngatedToChirp = isUngatedToCHIRPEndpoints();
  const handleOnPageChange = ({
    target: {
      value
    }
  }) => {
    const targetPage = value - 1;
    setCurrentPage(value);
    fetchDocumentVisitors({
      limit: pageLimit,
      offset: targetPage * pageLimit,
      deckId,
      documentVisitorSearchQuery
    });
    const summaryHeaderElement = document.getElementById('summary-header');
    if (summaryHeaderElement) {
      summaryHeaderElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const {
    data: documentVisitorsCHIRP
  } = useGetDocumentVisitors({
    documentId: deckId,
    limit: pageLimit,
    offset: currentPage === 1 ? 0 : (currentPage - 1) * pageLimit,
    searchQuery: searchQueryCHIRP
  });
  const renderPaginator = () => {
    const pageCount = hasMore ? Infinity : currentPage;
    return /*#__PURE__*/_jsx(TFlex, {
      justify: "center",
      align: "baseline",
      children: /*#__PURE__*/_jsx(Paginator, {
        "data-test-id": "summary-recipients-table-paginator",
        maxVisiblePageButtons: 1,
        onPageChange: handleOnPageChange,
        page: currentPage,
        pageCount: pageCount,
        paddingBlockStart: "400"
      })
    });
  };
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    direction: "column",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "SUMMARY_LOAD"
    }), /*#__PURE__*/_jsxs(Table, {
      "data-test-id": "summary-recipients-table",
      children: [/*#__PURE__*/_jsxs("colgroup", {
        children: [/*#__PURE__*/_jsx("col", {}), /*#__PURE__*/_jsx("col", {
          width: "150"
        }), /*#__PURE__*/_jsx("col", {
          width: "150"
        })]
      }), /*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "summary.recipientsTable.header.name"
            })
          }), /*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(View, {
              textAlign: "right",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "summary.recipientsTable.header.views"
              })
            })
          }), /*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(View, {
              textAlign: "right",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "summary.recipientsTable.header.lastViewed"
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: isUngatedToChirp ? documentVisitorsCHIRP === null || documentVisitorsCHIRP === void 0 ? void 0 : documentVisitorsCHIRP.documentVisitors.map(visitor => /*#__PURE__*/_jsx(SummaryRecipientsTableRowCHIRP, {
          documentVisitor: visitor,
          onViewDetails: onViewDetailsCHIRP
        }, visitor.viewerId.toString())) : deckVisitors.map(deckVisitor => /*#__PURE__*/_jsx(SummaryRecipientsTableRow, {
          deckVisitor: deckVisitor,
          onViewDetails: partial(onViewDetails, deckVisitor)
        }, deckVisitor.get('vid').toString())).toList()
      })]
    }), renderPaginator()]
  });
};
export default SummaryRecipientsTable;